import httpService from "./httpService";

const apiService = {
  // logIn
  logIn(data) {
    return httpService.post(`user/login`, data);
  },

  // get user by id
  getUser(userId) {
    return httpService.get(`user/${userId}`)
  },

  // create order
  createOrder(data) {
    return httpService.post('Order', data)
  },

  // get orders by company
  getOrdersByCompany(companyId, params) {
    return httpService.get(`Order/company/${companyId}`, { params })
  },

  // get paid orders by company
  getPaidOrders(companyId, params) {
    return httpService.get(`Order/company/${companyId}/paid`, { params })
  },

  // get orders summary
  getOrdersSummary(companyId, params) {
    return httpService.get(`Order/company/${companyId}/summary`, { params })
  },

  // delete order
  deleteOrder(orderId) {
    return httpService.delete(`Order/${orderId}`)
  },

  // update order payment
  updatePayment(orderId, data) {
    return httpService.patch(`Order/${orderId}/payment`, data)
  },

  // get daily cancelled orders parameters
  getDailyCancelledParams(companyId, params) {
    return httpService.get(`Order/company/${companyId}/daily`, { params })
  },

  // register user
  register(data) {
    return httpService.post('User/register', data)
  },

  // get products by company
  getProductsByCompany(companyId) {
    return httpService.get(`Product/company/${companyId}`)
  },

  // create product
  createProduct(data) {
    return httpService.post('Product', data)
  },

  // save invoice
  saveInvoice (data) {
    return httpService.post('Invoice', data)
  },

  // get invoices by company
  getInvoicesByCompany (companyId) {
    return httpService.get(`Invoice/company/${companyId}`)
  },

  // upload proof of payment (subscription)
  uploadPop(formData) {
    return httpService.post('Company/pop', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  // submit document (POP)
  createDocument(data) {
    return httpService.post('Document', data)
  },

  // get documents by company
  getDocumentsByCompany(companyId) {
    return httpService.get(`Document/company/${companyId}`)
  },

  // get daily summary
  getDailySummary(companyId) {
    return httpService.get(`DailySummary/company/${companyId}`)
  },

  // create daily summary
  createDailySummary(data) {
    return httpService.post('DailySummary', data)
  },

  // create expense
  createExpense(data) {
    return httpService.post('Expense', data)
  },

  // get expenses by company
  getExpensesByCompany(companyId) {
    return httpService.get(`Expense/company/${companyId}`)
  },

  // get profit summary by company with date range
  getProfitByCompany(companyId, params) {
    return httpService.get(`Expense/company/${companyId}/profit`, { params })
  },
};

export default apiService;
